<template>
  <div>
    <a-row>
      <a-tooltip v-if="!onEdit" :title="$t('message.button.setting')"><a-icon  type="setting" style="position: absolute;right: 12px;top: -10px;z-index: 1;" @click="editDashboard"/></a-tooltip>
      <a-tooltip v-if="onEdit" :title="$t('message.button.save')"><a-icon  type="save" style="position: absolute;right: 36px;top: -10px;z-index: 1;" @click="save"/></a-tooltip>
      <a-tooltip v-if="onEdit" :title="$t('message.button.cancel')"><a-icon  type="undo" style="position: absolute;right: 12px;top: -10px;z-index: 1;" @click="cancel"/></a-tooltip>
    </a-row>
    <a-row :gutter="16" class="dashboard-container " v-bind:class="{onEdit:onEdit}" >
      <dashboard-item v-for="(item) in dashboardData" :span="item.span" :edit="onEdit" :deleted="item.deleted" :dashboard-key="item.key" v-bind:key="item.key" :data-id="item.key" :on-delete="onDelete" :un-delete="unDelete">
        <template v-if="onEdit||!item.deleted">
          <ProductSoldYoyCard v-if="item.key==='all_order_quantity'" product-sold-type="ORDER_QUANTITY"/>
          <AllProductSold v-if="item.key==='all_product_sold'" />
          <ChannelProductSoldCard v-if="item.key==='channel_product_sold'"  style="min-height: 181px;"/>
          <InventoryTurnOver v-if="item.key==='inventory_turn_over'"  style="min-height: 181px;"/>
          <MonthlyProductSoldAndProductRanking v-if="item.key==='monthly_product_sold_and_item_ranking'" />
          <ToDeliver v-if="item.key==='to_deliver'"  style="min-height: 360px"/>
          <ToReplenish v-if="item.key==='to_supplement'"  style="min-height: 360px"/>
          <ToInbound v-if="item.key==='to_inbound'"  style="min-height: 360px"/>
          <AllAuthorizedShops v-if="item.key==='all_authorized_shop'" />
          <ShopProductSoldPieChartCard v-if="item.key==='proportion_of_shop_product_sold'" />
        </template>
      </dashboard-item>
    </a-row>
  </div>
</template>

<script>
import {baseMixin} from '../../store/app-mixin'
import AllProductSold from './components/AllProductSold'
import ToInbound from './components/ToInbound'
import AllGmv from './components/AllGmv'
import MonthlyProductSoldAndProductRanking from './components/MonthlyProductSoldAndProductRanking'
import ToReplenish from './components/ToReplenish'
import ProductSoldYoyCard from './components/ProductSoldYoyCard'
import ChannelProductSoldCard from './components/ChannelProductSoldCard'
import AllAuthorizedShops from './components/AllAuthorizedShops'
import ShopProductSoldPieChartCard from './components/ShopProductSoldPieChartCard'
import InventoryTurnOver from './components/InventoryTurnOver'
import ToDeliver from './components/ToDeliver'
import Sortable from 'sortablejs'
import DashboardItem from './components/DashboardItem'
import request from '../../utils/request'
const initDashboardData = [{
  key: 'all_order_quantity',
  deleted: false,
  span: 6
}, {
  key: 'all_product_sold',
  deleted: false,
  span: 6
}, {
  key: 'channel_product_sold',
  deleted: false,
  span: 6
}, {
  key: 'inventory_turn_over',
  deleted: false,
  span: 6
}, {
  key: 'monthly_product_sold_and_item_ranking',
  deleted: false,
  span: 24
}, {
  key: 'to_deliver',
  deleted: false,
  span: 8
}, {
  key: 'to_supplement',
  deleted: false,
  span: 8
}, {
  key: 'to_inbound',
  deleted: false,
  span: 8
}, {
  key: 'all_authorized_shop',
  deleted: false,
  span: 18
}, {
  key: 'proportion_of_shop_product_sold',
  deleted: false,
  span: 6
}]
export default {
  name: 'Analysis',
  mixins: [baseMixin],
  components: {
    AllProductSold,
    ToInbound,
    AllGmv,
    MonthlyProductSoldAndProductRanking,
    ToReplenish,
    ProductSoldYoyCard,
    ChannelProductSoldCard,
    AllAuthorizedShops,
    ShopProductSoldPieChartCard,
    InventoryTurnOver,
    ToDeliver,
    DashboardItem
  },
  data () {
    return {
      onEdit: false,
      dashboardData: [],
      sortable: {}
    }
  },
  mounted () {
    this.getDashboardData()
  },
  methods: {
    initDrag () {
      const dashboardContainer = document.querySelector('.dashboard-container')
      let that = this
      this.sortable = new Sortable(dashboardContainer, {
        animation: 150,
        ghostClass: 'onDrag',
        handle: '.handle',
        onEnd: (evt) => {
          console.log('evt', evt)
          let newArray = that.dashboardData.slice(0)
          console.log('before:', newArray)
          newArray.splice(evt.newIndex, 0, newArray.splice(evt.oldIndex, 1)[0])
          console.log('end:', newArray)
          that.$nextTick(function () {
            that.dashboardData = newArray
          })
        }
      })
    },
    editDashboard () {
      this.onEdit = true
      this.initDrag()
    },
    onDelete (key) {
      console.log('onDelete', key)
      let newArray = this.dashboardData.slice(0)
      let i = 0
      for (; i < newArray.length; i++) {
        if (newArray[i].key === key) {
          break
        }
      }
      let item = newArray.splice(i, 1)[0]
      console.log('deleteItem', item)
      item.deleted = true
      newArray.splice(newArray.length, 0, item)
      console.log('delete result', newArray)
      this.$nextTick(() => {
        this.dashboardData = newArray
      })
    },
    unDelete (key) {
      console.log('unDelete', key)
      let newArray = this.dashboardData.slice(0)
      let i = 0
      for (; i < newArray.length; i++) {
        if (newArray[i].key === key) {
          break
        }
      }
      let item = newArray.splice(i, 1)[0]
      console.log('undeleteItem', item)
      item.deleted = false
      for (;i >= 0; i--) {
        if (!newArray[i].deleted) {
          break
        }
      }
      newArray.splice(i, 0, item)
      console.log('undelete result', newArray)
      this.$nextTick(() => {
        this.dashboardData = newArray
      })
    },
    save () {
      this.onEdit = false
      request({
        url: '/dashboard/config/save',
        method: 'post',
        data: this.dashboardData
      }).then(response => {
        // response.data = json
        console.log('response', response)
        if (response.data.success) {
          console.log('in success')
          this.$message.success('保存成功')
        } else {
          console.log('in fail')
          this.$message.error(response.data.errorMessage)
        }
        setTimeout(() => {
          this.$router.go(0)
        }, 1000)
      })
    },
    cancel () {
      this.onEdit = false
      this.getDashboardData()
    },
    getDashboardData () {
      request({
        url: '/dashboard/config',
        method: 'get'
      }).then(response => {
        // response.data = json
        this.dashboardData = response.data.model || initDashboardData
      })
    }
  }
}
</script>

<style lang="less" scoped>
.onDrag{
  background-color: #b0c8ca !important;
  border: solid 8px #b0c8ca !important;
}
.onEdit {
  /deep/ .dashboard-item{
    border: solid 8px #e3e3e3;
    background-color: #e3e3e3;
  }
  /deep/ .dashboard-item:hover{
    background-color: #b0c8ca;
    border: solid 8px #b0c8ca;
  }
}
/deep/ i:hover {
  color: cadetblue;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analysis.vue